/**
 * admin_database_refresh_controller.js — Admin > Database "Refresh" button (Stimulus).
 *
 * Recomputes every schema's cached status on the server, then re-renders the
 * page in place through window.chippiePageCheck.refresh(). The one owner of
 * that action for the Database Manager dashboard and the Schemas list.
 *
 * Values: url (the refresh-cache endpoint). Targets: label (the button text,
 * swapped for a progress label while the server works).
 *
 * Templates: templates/admin/database/dashboard.html, templates/admin/database/schemas.html
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = { url: String };
    static targets = ['label'];

    refresh() {
        this._busy(true);
        fetch(this.urlValue, { method: 'POST' })
            .then(function (response) { return response.json(); })
            .then((data) => {
                if (!data.success) throw new Error(data.error || 'Unknown error');
                window.chippiePageCheck.refresh();
            })
            .catch((error) => {
                alert('Failed to refresh cache: ' + error.message);
                this._busy(false);
            });
    }

    _busy(busy) {
        this.element.disabled = busy;
        this.labelTarget.textContent = busy ? 'Refreshing...' : 'Refresh';
    }
}
